export default __webpack_public_path__ + "static/media/container-v.154eb7e2.png";